import { getAcquisitionsCardColumns } from "./AcquisitionsCard.config";

import AcquisitionsCard from "./AcquisitionsCard";

const AcquisitionsCardContainer = ({ items }: any) => {
  const columns = getAcquisitionsCardColumns();

  return <AcquisitionsCard items={items} columns={columns} />;
};

export default AcquisitionsCardContainer;
